exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-9a451cbe] {\n  width: 350px;\n}\n.el-dropdown-link[data-v-9a451cbe] {\n  cursor: pointer;\n  color: #409eff;\n  font-size: 12px;\n}\n.el-icon-arrow-down[data-v-9a451cbe] {\n  font-size: 12px;\n}\n", ""]);

// exports
